"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = App;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var entry_1 = require("./entry");
function App() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.ToastProvider, { placement: "top" }), (0, jsx_runtime_1.jsx)(entry_1.Entry, {})] }));
}
